import { FC, useCallback } from "react";
import { NavLink } from "react-router-dom";

import { ReactComponent as ArrowRight } from "../../assets/vectors/icons/arrow-right.svg";
import { useRouteInfo } from "../../hooks/route/useRouteInfo";

const ContentFooter: FC = () => {
	const { next, previous } = useRouteInfo();

	const scrollToTop = useCallback(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="w-full mx-auto grid grid-cols-2 gap-4 py-4 md:py-12">
			{previous?.url ? (
				<NavLink
					key={previous?.url}
					className="text-blue-800 flex gap-x-4 md:gap-x-6 items-center w-full md:w-80 pl-4 md:pl-5 -ml-4 md:-ml-5 pr-4 md:pr-5 py-6 border-2 border-transparent text-base leading-base text-link rounded-lg group focus:text-link focus:bg-primary-hover/5 focus:border-link focus:border-opacity-100 focus:border-2 focus:ring-1 focus:ring-offset-4 focus:ring-blue-40 active:ring-0 active:ring-offset-0 hover:bg-gray-50 flex-row justify-self-start text-left"
					to={previous?.url}
					onClick={scrollToTop}
				>
					<span className="flex flex-col gap-1 justify-end items-start">
						<span className="uppercase font-semibold tracking-wide text-gray-400 text-sm flex items-center gap-1"><ArrowRight className="rotate-180 text-gray-400" width={16} height={16} /> Previous topic</span>
						<span className="text-secondary group-hover:underline">{previous?.label}</span>
					</span>
				</NavLink>
			) : (
				<div></div>
			)}
			{next?.url ? (
				<NavLink
					key={next?.url}
					className="text-blue-800 flex gap-x-4 md:gap-x-6 items-center w-full md:w-80 pl-4 md:pl-5 pr-4 md:pr-5 -mr-4 md:-mr-5 py-6 border-2 border-transparent text-base leading-base text-link rounded-lg group focus:text-link focus:bg-primary-hover/5 focus:border-link focus:border-opacity-100 focus:border-2 focus:ring-1 focus:ring-offset-4 focus:ring-blue-40 active:ring-0 active:ring-offset-0 hover:bg-gray-50 flex-row-reverse justify-self-end text-right"
					to={next?.url}
					onClick={scrollToTop}
				>
					<span className="flex flex-col gap-1 justify-end items-end">
						<span className="uppercase font-semibold tracking-wide text-gray-400 text-sm flex items-center gap-1">Next topic <ArrowRight className="text-gray-400" width={16} height={16} /></span>
						<span className="text-secondary group-hover:underline">{next?.label}</span>
					</span>
				</NavLink>
			) : (
				<div></div>
			)}
		</div>
	);
};

export { ContentFooter };
